var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7 11.173 3.378 1.727c.635.325 1.394-.197 1.27-.898l-.644-3.659 2.733-2.592c.519-.494.23-1.35-.486-1.452l-3.776-.534L7.785.436c-.294-.581-1.275-.581-1.569 0l-1.69 3.33L.75 4.3C.035 4.4-.255 5.258.265 5.752l2.733 2.591-.645 3.66c-.123.697.634 1.226 1.27.897L7 11.173zm2.624-.583L7.408 9.457a.895.895 0 0 0-.815 0L4.377 10.59l.423-2.4a.837.837 0 0 0-.251-.753L2.756 5.736l2.477-.35a.873.873 0 0 0 .659-.466L7 2.736 8.11 4.92a.87.87 0 0 0 .658.466l2.477.35-1.793 1.7a.838.838 0 0 0-.25.754l.422 2.4z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.b835fcab.svg";
export { ForwardRef as ReactComponent };